import { useStylesConfigValue } from "../../stores/styles-config";
import { cn } from "../../utils";
import type { ChatLayoutProps } from "./types";

export function ChatLayout({ children, headerSlot, inputSlot, errorSlot }: ChatLayoutProps) {
  const showChatInput = useStylesConfigValue("showChatInput");
  const scrollSnap = useStylesConfigValue("scrollSnap");

  return (
    <div className="flex min-h-0 flex-1 flex-col w-full">
      {headerSlot}
      <div
        className={cn(
          "flex flex-1 flex-col items-center overflow-y-auto",
          scrollSnap && "snap-y snap-mandatory",
        )}
      >
        <div className="max-w-2xl w-full px-6 flex flex-col flex-1 min-h-full">
          {children}
          {errorSlot}
        </div>
      </div>

      {showChatInput && inputSlot}
    </div>
  );
}
